module.exports = __webpack_public_path__ + "static/img/v6.b421b14.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vip/v6.svg
// module id = Xzov
// module chunks = 0